module.exports = __webpack_public_path__ + "static/img/p3.419bead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/panorama/p3.png
// module id = nl47
// module chunks = 0